import ai_bot_avatar from '../assets/logo_white_transparent_no_text.png';
import user_avatar from '../assets/user_avatar.png';

export default function ChatMessage(props) {
    const avatar = props.isUser ? user_avatar : ai_bot_avatar;
    const className = props.isUser ? "user" : "ai-bot";
    const name = props.isUser ? "You" : "Living Legend (AI)";
    const timestamp = props.timestamp.toLocaleTimeString([], {
        hour: 'numeric',
        minute: '2-digit',
    }).toLocaleLowerCase();
    return (
        <div className={`signup-flow-chat-message ${className}`}>
            <img src={avatar} alt="ai-bot" className={`signup-flow-chat-message-avatar ${className}`} />
            <div className="signup-flow-chat-message-content">
                <div className="signup-flow-chat-message-header">
                    <p className="signup-flow-chat-message-name">{name}</p>
                    <p className="signup-flow-chat-message-timestamp">{timestamp}</p>
                </div>
                <p className="signup-flow-chat-message-text">{props.message}</p>
            </div>
        </div>
    )
}